<template>
  <v-card class="py-3 px-3 mb-3">
    <div class="d-flex align-center justify-space-between mb-3">
      <h4 class="text-uppercase">{{ $vuetify.lang.t('$vuetify.labels.orderState') }}</h4>
    </div>

    <template v-if="order">
      {{ order.state.label[defaultLanguage] }}
    </template>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    customerImage: {
      type: String,
      default: null,
    },
  },

  computed: {
    ...mapGetters({
      getOrder: 'orders/getOrder',
      defaultLanguage: 'languages/defaultLanguage',
    }),

    order() {
      return this.getOrder(Number(this.$route.params.id));
    },
  },
};
</script>
